module.exports = __webpack_public_path__ + "static/img/element_03.a815f67.png";


//////////////////
// WEBPACK FOOTER
// ./static/ningbo/ningbo_log/element_03.png
// module id = SJzZ
// module chunks = 24